import React, { useContext } from 'react'
import useLanguageContext from '@dataplace.ai/functions/hooks/useLanguageContext'
import { ProductFruits } from 'react-product-fruits'
import { AuthContext } from './AuthContext'

function ProductFruitsProvider(): JSX.Element | null {
  const { language } = useLanguageContext()
  const authContext = useContext(AuthContext)

  if (!authContext?.userData?.user?.uid) return null

  return (
    <ProductFruits
      key={language}
      language={language}
      lifeCycle='unmount'
      user={{
        username: authContext.userData.user.uid,
      }}
      workspaceCode={process.env.NX_PRODUCT_FRUITS_WORKSPACE_CODE ?? ''}
    />
  )
}

export default ProductFruitsProvider
